<div class="content-page">
  <div class="container container-sm">
    <div class="page-header">
      <span class="section-tag">Drip Mode</span>
      <h1 class="page-title">Natural indexing with Drip Mode</h1>
      <p class="page-subtitle">Spread your submissions over time to simulate organic link discovery patterns.</p>
    </div>

    <div class="content-block">
      <h2>What is Drip Mode?</h2>
      <p>Drip Mode is a scheduling feature that spreads your URL submissions over a configurable time window. Instead of submitting hundreds of URLs at once, you can space them out over hours or days. This mimics how search engines expect to see content discovered organically.</p>
    </div>

    <div class="content-block">
      <h2>Why use Drip Mode?</h2>
      <p>When search engines detect a sudden spike of "discovered" URLs from a single source, it can trigger spam filters. Drip Mode helps you:</p>
      <ul class="content-list">
        <li>Avoid triggering spam detection algorithms</li>
        <li>Simulate natural link building velocity</li>
        <li>Maintain a more consistent indexation rate</li>
        <li>Reduce the risk of manual review by search quality teams</li>
      </ul>
    </div>

    <div class="content-block">
      <h2>How to use Drip Mode</h2>
      <ol class="content-list numbered">
        <li>Submit your URLs as normal via the dashboard</li>
        <li>Enable Drip Mode in the configuration step</li>
        <li>Set your preferred interval (e.g., 5 minutes between submissions)</li>
        <li>Submit — we'll handle the rest automatically</li>
      </ol>
    </div>

    <div class="scenarios">
      <h2>Common scenarios</h2>
      <div class="scenarios-grid">
        <div class="scenario-card">
          <h3>Small batch (10-50 URLs)</h3>
          <p>Use a 1-2 minute interval. Submissions complete within the hour.</p>
        </div>
        <div class="scenario-card">
          <h3>Medium batch (50-200 URLs)</h3>
          <p>Use a 5-10 minute interval. Spreads across 4-24 hours.</p>
        </div>
        <div class="scenario-card">
          <h3>Large batch (200+ URLs)</h3>
          <p>Use a 30-60 minute interval. Spreads across 1-3 days for natural pacing.</p>
        </div>
      </div>
    </div>

    <div class="content-block">
      <h2>Frequently asked questions</h2>
      <div class="faq-item">
        <h3>Can I cancel a drip job?</h3>
        <p>Yes. Drip jobs can be cancelled at any time from your dashboard. Already-submitted URLs will remain in the queue.</p>
      </div>
      <div class="faq-item">
        <h3>Does Drip Mode cost extra?</h3>
        <p>No. Drip Mode is a free feature included with all credit packages. You only pay for the URLs submitted.</p>
      </div>
      <div class="faq-item">
        <h3>What happens if I run out of credits mid-drip?</h3>
        <p>The drip job will pause until you top up credits. Once added, it will automatically resume from where it left off.</p>
      </div>
    </div>

    <div class="cta-block">
      <h2>Ready to try Drip Mode?</h2>
      <p>Submit your URLs with natural pacing.</p>
      <a routerLink="/submit" class="btn btn-primary">Try Drip Mode</a>
    </div>
  </div>
</div>
